import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { IncludedSection } from '../components/IncludedSection';
import { BonusesSection } from '../components/BonusesSection';
import { TargetAudience } from '../components/TargetAudience';
import { StepsSection } from '../components/StepsSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { FAQSection } from '../components/FAQSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full overflow-hidden" data-id="element-350">
      <HeroSection data-id="element-351" />
      <PainSection data-id="element-352" />
      <FailedSolutions data-id="element-353" />
      <SolutionSection data-id="element-354" />
      <TestimonialSection data-id="element-355" />
      <IncludedSection data-id="element-356" />
      <BonusesSection data-id="element-357" />
      <TargetAudience data-id="element-358" />
      <StepsSection data-id="element-359" />
      <ValueStackSection data-id="element-360" />
      <FAQSection data-id="element-361" />
      <PricingCTA data-id="element-362" />
      <Footer data-id="element-363" />
    </main>;
}